const QueryParams = {
  parse(params = '') {
    const rawParams = params.replace('?', '').split('&');
    const extractedParams = {};
    rawParams.forEach((item) => {
      item = item.split('=');
      // eslint-disable-next-line
      extractedParams[item[0]] = item[1];
    });
    return extractedParams;
  }
};

export default QueryParams;
